// extracted by mini-css-extract-plugin
export default {"logoLink":"Ldb6GgdO"};